import dayjs from 'dayjs';
import _ from 'lodash';

export const API = {
  operations: {
    path: '/operation-lists?populate[id_department][fields][0]=name_department&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_service]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_mexal_person_in_charge]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_supplier]=%2A&populate[id_reservation][populate][id_booking][populate][id_marina]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: data?.data.map((item) => ({
        id: item?.id,
        attributes: {
          ...item?.attributes,
          status_operation_BC_id: {
            status_operation_BC: item?.attributes.status_operation_BC,
            id: item?.id,
          },
          status_operation_BF_id: {
            status_operation_BF: item?.attributes.status_operation_BF,
            id: item?.id,
          },
          OC_BC_number_id: {
            OC_BC_number: item?.attributes.OC_BC_number,
            id: item?.id,
          },
          OF_BF_number_id: {
            OF_BF_number: item?.attributes.OF_BF_number,
            id: item?.id,
          },
          OC_fees_id: {
            OC_fees: item?.attributes.OC_fees,
            id: item?.id,
          },
          date_out: `${item?.attributes?.requested_date
            ? dayjs(item?.attributes?.requested_date).format('DD-MM-YYYY')
            : '-'
            } / ${item?.attributes?.check_out_date ? dayjs(item?.attributes?.check_out_date).format('DD-MM-YYYY') : '-'}`,
          id: item?.id,
          status_operation_booking_id: {
            status_operation_booking: item?.attributes.status_operation_booking,
            id: item?.id,
          },
          supplier_correspondent_id: {
            supplier_correspondent: item?.attributes.supplier_correspondent,
            id: item?.id,
          },
          status_billing_id: {
            status_billing: item?.attributes.status_billing,
            id: item?.id,
          },
          billing_notes_id: {
            billing_notes: item?.attributes.billing_notes,
            id: item?.id,
          },
          service_reservation_request_id: {
            reservation_type: item?.attributes?.id_reservation?.data?.attributes?.reservation_type,
            booking: item?.attributes?.id_reservation?.data?.attributes?.id_booking?.data,
            service: item?.attributes?.id_service?.data?.attributes?.service
          },
        },
      })),
    }),
  },
  operation: {
    path: '/operation-lists/{{id}}?populate[id_technical_works][populate][yacht_crew_signature]=%2A&populate[id_technical_works][populate][na_tech_signature]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_technical_work][populate][id_user_technicians][populate][id_users_permissions_user][fields]=name,surname&populate[id_mexal_person_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_yacht]=%2A&populate[id_reservation][populate][id_arrival_departure_formality]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_service]=%2A&populate[id_supplier]=%2A&populate[id_reservation_piloti_in][populate][id_yacht]=%2A&populate[id_yacht][populate][id_flag]=%2A&populate[id_technical_works]=%2A&populate[id_reservation_piloti_out]=%2A&populate[id_delivery_note][populate][id_logbook]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  services: {
    path: '/service-operation-lists?pagination[page]=1&pagination[pageSize]=1000&sort[service]=asc',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: item.attributes.service,
        id: item.id,
      })),
  },

  update: {
    path: '/operation-lists/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        id_department: body?.id_department?.id,
        id_agent_NA: body?.id_agent_NA?.id,
        id_mexal_person_in_charge: body?.id_mexal_person_in_charge?.id,
        id_supplier: body?.id_supplier?.id,
        id_yacht: body?.id_yacht?.id,
        id_marina: body?.id_marina?.id,
        id_service: body?.id_service?.id,
        id_technical_work: body?.id_technical_work?.id,
        status_operation_BF: body?.status_operation_BF?.id,
        status_operation_BC: body?.status_operation_BC?.id,
        status_operation_booking: body?.status_operation_booking?.id,
        check_out_date: body?.check_out_date
          ? dayjs(body?.check_out_date).format('YYYY-MM-DD')
          : null,
        operation_date: body?.operation_date
          ? dayjs(body?.operation_date).format('YYYY-MM-DD')
          : null,
        requested_date: body?.requested_date
          ? dayjs(body?.requested_date).format('YYYY-MM-DD')
          : null,
        requested_hour: body?.requested_hour
          ? dayjs(body?.requested_hour, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        account_type: body?.account_type?.label,
        status_billing: body?.status_billing?.id,
      },
    }),
  },
  delete: {
    path: '/operation-lists/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/operation-lists',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          id_agent_NA: body?.id_agent_NA?.id,
          id_mexal_person_in_charge: body?.id_mexal_person_in_charge?.id,
          id_supplier: body?.id_supplier?.id,
          id_yacht: body?.id_yacht?.id,
          id_marina: body?.id_marina?.id,
          id_service: body?.id_service?.id,
          id_technical_work: body?.id_technical_work?.id,
          status_operation_BF: body?.status_operation_BF?.id,
          status_operation_BC: body?.status_operation_BC?.id,
          status_operation_booking: body?.status_operation_booking,
          check_out_date: body?.check_out_date
            ? dayjs(body?.check_out_date).format('YYYY-MM-DD')
            : null,
          operation_date: body?.operation_date
            ? dayjs(body?.operation_date).format('YYYY-MM-DD')
            : null,
          requested_date: body?.requested_date
            ? dayjs(body?.requested_date).format('YYYY-MM-DD')
            : null,
          requested_hour: body?.requested_hour
            ? dayjs(body?.requested_hour, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          account_type: body?.account_type?.label,
          type_of_contact: body?.type_of_contact?.id,
          status_billing: body?.status_billing?.id,
        },
      };
    },
  },
  updateFromList: {
    path: '/operation-lists/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const status_operation_BC = body?.status_operation_BC?.id
        ? { status_operation_BC: body?.status_operation_BC?.id }
        : null;
      const status_operation_BF = body?.status_operation_BF?.id
        ? { status_operation_BF: body?.status_operation_BF?.id }
        : null;
      const requested_hour = body?.requested_hour
        ? {
          requested_hour: body?.requested_hour
            ? dayjs(body?.requested_hour, 'HH:mm:ss').format('HH:mm:ss')
            : null,
        }
        : null;

      return {
        data: {
          ..._.omit(body, ['status_operation_BC', 'status_operation_BF']),
          ...status_operation_BC,
          ...status_operation_BF,
          ...requested_hour,
        },
      };
    },
  },
  updateAllRows: {
    path: '/operation-lists/updateMany',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const status_operation_booking = body?.status_operation_booking
        ? { status_operation_booking: body?.status_operation_booking }
        : null;
      const status_billing = body?.status_billing ? { status_billing: body?.status_billing } : null;

      return {
        data: {
          ..._.omit(body, ['status_operation_booking', 'status_billing']),
          ...status_operation_booking,
          ...status_billing,
        },
      };
    },
  },
};
